export default __webpack_public_path__ + "static/Muli-Regular-16065de275282090bb6bc589044b9f37.woff2";